<div class="container py-2">
    <!-- Status Timeline Progress -->
    <div class="lead-status-timeline mt-4">
      <div class="status-progress">
        <div v-for="(step, index) in steps" :key="index" class="status-step">
          <div :class="['circle', index <= current_step ? 'active' : '']">
            {{ index + 1 }}
          </div>
          <div class="label">{{ step }}</div>
          <div v-if="index < steps.length - 1" class="line"></div>
        </div>
      </div>
    </div>

    <!-- Dynamic Interaction History -->
    <h5 class="card-title mt-4 mb-2">Interaction History</h5>
    <div class="card border-0">
        <div class="card-body position-relative">
            <div class="timeline-line position-absolute top-0 bottom-0 start-0 ms-4"></div>
            <!-- Scrollable container -->
            <div class="timeline-scrollable me-1 status-overflow">
              <div
                v-for="(entry, index) in time_line_entries"
                :key="index"
                class="timeline-entry d-flex flex-column position-relative mb-5"
              >
                <div class="timeline-dot position-absolute top-left">
                  <span class="dot custom-header"></span>
                </div>
                <div class="ms-4 mb-1">
                  <small class="fw-bold text-xs">{{ entry.date }} - {{ entry.time }}</small>
                </div>
                <div class="ms-4 flex-grow-1 shadow rounded-lg">
                  <div class="border rounded-lg p-3">
                    <div class="fw-semibold text-xs">{{ entry.title }}</div>
                    <div class="text-muted text-xxs">{{ entry.message }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
       </div>          
  </div>